import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import MuiButton from "@material-ui/core/Button";

import { palette } from "../../theme/brand";

// Brand-styled button, replacing the template `CustomButtons/Button`.
const COLORS = {
  primary: palette.primary,
  secondary: palette.secondary,
  accent: palette.accent,
  success: palette.success
};

const styles = {
  button: {
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "8px",
    padding: "10px 24px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none"
    }
  },
  round: {
    borderRadius: "30px"
  },
  fullWidth: {
    width: "100%"
  }
};

function Button({
  classes,
  color,
  round,
  fullWidth,
  className,
  children,
  ...rest
}) {
  const backgroundColor = COLORS[color] || COLORS.primary;
  return (
    <MuiButton
      {...rest}
      className={[
        classes.button,
        round ? classes.round : "",
        fullWidth ? classes.fullWidth : "",
        className || ""
      ]
        .join(" ")
        .trim()}
      style={{ backgroundColor }}
    >
      {children}
    </MuiButton>
  );
}

Button.defaultProps = {
  color: "primary",
  round: false,
  fullWidth: false
};

Button.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "secondary", "accent", "success"]),
  round: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
};

export default withStyles(styles)(Button);



// WEBPACK FOOTER //
// ./src/components/ui/Button.jsx